import React from "react";

function Icon({ className }) {
  return (
    <svg
      width="135"
      height="16"
      viewBox="0 0 135 16"
      fill="none"
      className={className}
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0)">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M0 1.37109H3.45562L7.2426 7.38293L11.0296 1.37109H14.4852V15.5723H11.3136V6.29417L7.2426 12.3533H7.14793L3.12426 6.34151V15.5723H0V1.37109Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M32.7578 8.52087C32.7578 4.4972 35.9294 1.18359 40.3318 1.18359C42.9353 1.18359 44.4975 1.84632 46.0123 3.12442L44.0241 5.44395C42.9884 4.506 41.6341 3.99815 40.2371 4.02383C39.1029 4.06096 38.0291 4.54417 37.2491 5.36849C36.4691 6.19281 36.0459 7.29163 36.0714 8.4262C36.0453 9.01568 36.1406 9.60424 36.3514 10.1554C36.5622 10.7065 36.8839 11.2085 37.2967 11.6301C37.7094 12.0518 38.2044 12.3841 38.751 12.6065C39.2975 12.829 39.8839 12.9368 40.4738 12.9232C41.5317 12.9518 42.5729 12.6543 43.456 12.0712V10.083H40.2371V7.38478H46.533V13.586C44.7968 15.0424 42.5978 15.8313 40.3318 15.8108C35.8347 15.8108 32.7578 12.7339 32.7578 8.52087Z"
          fill="currentColor"
        />
        <path
          d="M52.9235 1.37109H49.752V15.5817H52.9235V1.37109Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M55.9054 8.52087C55.9054 4.4972 59.0297 1.18359 63.4794 1.18359C66.225 1.18359 67.8344 2.083 69.2072 3.36111L67.1717 5.68064C66.0356 4.68655 64.8995 4.07117 63.4321 4.07117C61.0179 4.07117 59.2664 6.05933 59.2664 8.47354C59.2664 10.9351 60.9705 12.9232 63.4321 12.9232C65.0889 12.9232 66.1303 12.3079 67.2664 11.2664L69.3019 13.3019C68.5568 14.1373 67.6348 14.796 66.603 15.23C65.5712 15.6641 64.4556 15.8625 63.3374 15.8108C62.3665 15.8362 61.4004 15.6661 60.4965 15.3105C59.5927 14.955 58.7696 14.4213 58.0762 13.7411C57.3828 13.061 56.8333 12.2484 56.4604 11.3516C56.0875 10.4548 55.8988 9.49211 55.9054 8.52087Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M72.5205 1.37109H75.6921V12.732H82.9347V15.5723H72.5205V1.37109Z"
          fill="currentColor"
        />
        <path
          d="M88.6628 1.37109H85.4912V15.5817H88.6628V1.37109Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M92.2607 1.37109H95.1957L102.012 10.1285V1.37109H105.136V15.5723H102.438L95.4323 6.53086V15.5723H92.2607V1.37109Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M108.639 1.37109H111.81V7.57228L117.68 1.37109H121.562L115.645 7.38293L121.798 15.5723H117.964L113.514 9.51311L111.81 11.2172V15.5723H108.639V1.37109Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M122.557 13.4894L124.403 11.3119C125.728 12.3533 127.101 13.016 128.758 13.016C130.415 13.016 130.841 12.5427 130.841 11.6906C130.841 10.8859 130.32 10.5072 127.906 9.89178C125.492 9.2764 123.125 8.37699 123.125 5.53675C123.125 2.98054 125.208 1.2764 128.19 1.2764C130.144 1.22433 132.054 1.86107 133.586 3.07521L131.929 5.44208C130.843 4.59116 129.521 4.09533 128.142 4.02196C126.912 4.02196 126.296 4.59 126.296 5.25273C126.296 6.19947 126.912 6.48349 129.421 7.14622C131.929 7.80894 134.012 8.8977 134.012 11.4066C134.012 14.2468 131.835 15.8563 128.663 15.8563C126.403 15.8582 124.225 15.0138 122.557 13.4894Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M27.6452 0.710059L27.0771 0.899408L26.8878 1.42012L26.7458 0.899408L26.1777 0.710059L26.7458 0.568047L26.8878 0L27.0771 0.568047L27.6452 0.710059Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M22.2955 1.37345L21.4908 1.65747L21.2068 2.46221L20.9701 1.65747L20.118 1.37345L20.9701 1.13676L21.2068 0.332031L21.4908 1.13676L22.2955 1.37345ZM21.4908 3.45629L19.834 3.977L19.3133 5.63381L18.7925 3.977L17.1357 3.45629L18.7925 2.98292L19.3133 1.32611L19.834 2.98292L21.4908 3.45629ZM29.3961 1.84682L28.544 2.08351L28.26 2.93558L28.0233 2.08351L27.1712 1.84682L28.0233 1.61014L28.26 0.758067L28.544 1.61014L29.3961 1.84682Z"
          fill="currentColor"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M24.8991 1.84526L23.7156 1.37189L22.3902 4.44881L23.5263 4.96952L24.8991 1.84526ZM25.8458 1.46656L19.834 15.7151L19.55 15.9991C19.4282 16.0466 19.293 16.0466 19.1713 15.9991L17.4198 15.1944C17.2937 15.1374 17.1927 15.0364 17.1358 14.9103C17.0889 14.7722 17.0889 14.6224 17.1358 14.4843L23.2896 0.377802C23.3793 0.273285 23.493 0.192071 23.621 0.141116C23.7427 0.0935863 23.8779 0.0935863 23.9997 0.141116L25.5618 0.803838C25.6288 0.824176 25.6898 0.860735 25.7394 0.910277C25.7889 0.959819 25.8255 1.02081 25.8458 1.08786C25.8933 1.20962 25.8933 1.3448 25.8458 1.46656Z"
          fill="currentColor"
        />
        <path
          d="M23.0531 9.65692H26.272L24.6626 5.72793L26.1773 1.98828L32.0945 15.5741H28.7336L27.4081 12.4025H21.917L23.0531 9.65692Z"
          fill="currentColor"
        />
      </g>
      <defs>
        <clipPath id="clip0">
          <rect width="134.012" height="16" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
}

export default Icon;
